module.exports = __webpack_public_path__ + "static/media/chart3.99e86f79.jpg";